enum MessageStatusEnum {
    Success = 0,
    Warning = 1,
    Error = 2,
    Other = 3,
}

export default MessageStatusEnum;
